import { render, staticRenderFns } from "./NewTermsPage.vue?vue&type=template&id=24fd0f92&scoped=true"
import script from "./NewTermsPage.vue?vue&type=script&lang=js"
export * from "./NewTermsPage.vue?vue&type=script&lang=js"
import style0 from "./NewTermsPage.vue?vue&type=style&index=0&id=24fd0f92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fd0f92",
  null
  
)

export default component.exports